var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticStyle: { height: "100%", background: "transparent" },
      attrs: { flat: "" },
    },
    [
      _c(
        "v-item-group",
        {
          attrs: { mandatory: "", "active-class": "white--text" },
          model: {
            value: _vm.filterToggle,
            callback: function ($$v) {
              _vm.filterToggle = $$v
            },
            expression: "filterToggle",
          },
        },
        [
          _c(
            "v-subheader",
            { staticStyle: { display: "inline", cursor: "default" } },
            [_vm._v("Filter:")]
          ),
          _vm._v(" "),
          _c("v-item", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ active, toggle }) {
                  return _c(
                    "v-chip",
                    {
                      staticClass: "chipFilter",
                      attrs: {
                        color: active ? "primary" : "default",
                        selected: active,
                      },
                      on: { click: toggle },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.numberWithCommas(_vm.currentSelection.length)
                          ) +
                          " Selected Cell\n      "
                      ),
                    ]
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("v-item", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ active, toggle }) {
                  return _c(
                    "v-chip",
                    {
                      staticClass: "chipFilter",
                      attrs: {
                        color: active ? "primary" : "default",
                        selected: active,
                      },
                      on: { click: toggle },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.numberWithCommas(_vm.pendingLogs.length)) +
                          " Pending\n      "
                      ),
                    ]
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("v-item", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ active, toggle }) {
                  return _c(
                    "v-chip",
                    {
                      staticClass: "chipFilter",
                      attrs: {
                        color: active ? "primary" : "default",
                        selected: active,
                      },
                      on: { click: toggle },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("rule")]),
                      _vm._v("\n        Checked\n      "),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      [
        _c("v-data-table", {
          staticClass: "execution-detailed-logs mt-1 five-items",
          attrs: {
            headers: _vm.headers,
            pagination: _vm.pagination,
            items: _vm.filteredLogs,
            "select-all": "",
            rowsPerPageItems: _vm.rowsPerPageItems,
            "no-data-text": _vm.noDataText,
          },
          on: {
            "update:pagination": function ($event) {
              _vm.pagination = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "headers",
              fn: function (props) {
                return [
                  _c(
                    "tr",
                    [
                      _vm.isTenantAdmin
                        ? _c(
                            "th",
                            { staticClass: "cell-min-width pl-3 pr-0" },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "input-value": props.all,
                                  indeterminate: props.indeterminate,
                                  primary: "",
                                  "hide-details": "",
                                  color: "secondary",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.toggleAll.apply(null, arguments)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(props.headers, function (header) {
                        return _c(
                          "th",
                          {
                            key: header.text,
                            staticClass: "px-2",
                            class: [
                              "column sortable",
                              _vm.pagination.descending ? "desc" : "asc",
                              header.value === _vm.pagination.sortBy
                                ? "active"
                                : "",
                              ...header.classes,
                            ],
                            style: `text-align: ${header.align}`,
                            on: {
                              click: function ($event) {
                                return _vm.changeSort(header)
                              },
                            },
                          },
                          [
                            header.sortable
                              ? _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("arrow_upward"),
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(header.text) +
                                "\n          "
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ]
              },
            },
            {
              key: "items",
              fn: function (props) {
                return [
                  _c("tr", { attrs: { active: props.selected } }, [
                    _vm.isTenantAdmin
                      ? _c(
                          "td",
                          {
                            staticClass:
                              "cell-min-width text-xs-left pl-3 pr-0",
                          },
                          [
                            _c("v-checkbox", {
                              attrs: {
                                color: "default",
                                "hide-details": "",
                                label: "",
                              },
                              model: {
                                value: props.selected,
                                callback: function ($$v) {
                                  _vm.$set(props, "selected", $$v)
                                },
                                expression: "props.selected",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "cell-min-width pl-3 pr-3",
                        staticStyle: { position: "relative" },
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "icon-shadow",
                            attrs: { color: _vm.getStatus(props.item).color },
                          },
                          [_vm._v(_vm._s(_vm.getStatus(props.item).icon))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left px-0" },
                      [
                        _vm.logsMeta[props.item.location].displayName !=
                        _vm.logsMeta[props.item.location].fullName
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { left: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "location-btn",
                                                attrs: { small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setSelected(
                                                      props.item
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.logsMeta[
                                                    props.item.location
                                                  ].displayName
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(props.item.fullName)),
                                ]),
                              ]
                            )
                          : _c(
                              "v-btn",
                              {
                                staticClass: "location-btn",
                                attrs: { small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setSelected(props.item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.logsMeta[props.item.location]
                                      .displayName
                                  )
                                ),
                              ]
                            ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left pl-2 pr-2 cell-max-width" },
                      [_vm._v(_vm._s(props.item.details))]
                    ),
                  ]),
                ]
              },
            },
          ]),
          model: {
            value: _vm.selectedLogs,
            callback: function ($$v) {
              _vm.selectedLogs = $$v
            },
            expression: "selectedLogs",
          },
        }),
        _vm._v(" "),
        _vm.isTenantAdmin
          ? _c("div", [_c("Ignore", { attrs: { logs: _vm.selectedLogs } })], 1)
          : _vm._e(),
        _vm._v(" "),
        _c("v-divider"),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }